var _excluded = ["className"],
  _excluded2 = ["className", "variant"],
  _excluded3 = ["className"],
  _excluded4 = ["className"],
  _excluded5 = ["className"],
  _excluded6 = ["className"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as ToastPrimitives from '@radix-ui/react-toast';
import { cva } from 'class-variance-authority';
import { X } from 'lucide-react';
import * as React from 'react';
import { cn } from "../lib/utils";
var ToastProvider = ToastPrimitives.Provider;
var ToastViewport = /*#__PURE__*/React.forwardRef(function (_ref, ref) {
  var className = _ref.className,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement(ToastPrimitives.Viewport, _extends({
    ref: ref,
    className: cn('fixed top-0 z-[100] flex max-h-screen w-full flex-col-reverse p-4 sm:bottom-0 sm:right-0 sm:top-auto sm:flex-col md:max-w-[420px]', className)
  }, props));
});
ToastViewport.displayName = ToastPrimitives.Viewport.displayName;
var toastVariants = cva('data-[swipe=move]:transition-none group relative pointer-events-auto flex w-full items-center justify-between space-x-4 overflow-hidden rounded-md border p-4  shadow-lg transition-all data-[swipe=move]:translate-x-[var(--radix-toast-swipe-move-x)] data-[swipe=cancel]:translate-x-0 data-[swipe=end]:translate-x-[var(--radix-toast-swipe-end-x)] data-[state=open]:animate-in data-[state=closed]:animate-out data-[swipe=end]:animate-out data-[state=closed]:fade-out-80 data-[state=open]:slide-in-from-top-full data-[state=open]:sm:slide-in-from-bottom-full data-[state=closed]:slide-out-to-right-full', {
  variants: {
    variant: {
      default: 'bg-background border',
      destructive: 'group destructive border-destructive bg-destructive text-destructive-foreground dark:border-light dark:bg-light',
      success: 'bg-slime-25 border border-slime-300 dark:bg-background dark:border-border',
      error: 'bg-red-25 border border-red-300 text-red-500 dark:bg-background dark:border-border',
      loading: 'bg-yellow-25 border border-yellow-300 dark:bg-background dark:border-border'
    }
  },
  defaultVariants: {
    variant: 'default'
  }
});
var Toast = /*#__PURE__*/React.forwardRef(function (_ref2, ref) {
  var className = _ref2.className,
    variant = _ref2.variant,
    props = _objectWithoutProperties(_ref2, _excluded2);
  return /*#__PURE__*/React.createElement(ToastPrimitives.Root, _extends({
    ref: ref,
    className: cn(toastVariants({
      variant: variant
    }), className)
  }, props));
});
Toast.displayName = ToastPrimitives.Root.displayName;
var ToastAction = /*#__PURE__*/React.forwardRef(function (_ref3, ref) {
  var className = _ref3.className,
    props = _objectWithoutProperties(_ref3, _excluded3);
  return /*#__PURE__*/React.createElement(ToastPrimitives.Action, _extends({
    ref: ref,
    className: cn('inline-flex h-8 shrink-0 items-center justify-center rounded-md border bg-transparent px-3 text-sm font-medium ring-offset-background transition-colors hover:bg-secondary focus:outline-none focus:ring-2 focus:ring-ring focus:ring-offset-2 disabled:pointer-events-none disabled:opacity-50 group-[.destructive]:border-destructive/30 group-[.destructive]:hover:border-destructive/30 group-[.destructive]:hover:bg-destructive group-[.destructive]:hover:text-destructive-foreground group-[.destructive]:focus:ring-destructive', className)
  }, props));
});
ToastAction.displayName = ToastPrimitives.Action.displayName;
var ToastClose = /*#__PURE__*/React.forwardRef(function (_ref4, ref) {
  var className = _ref4.className,
    props = _objectWithoutProperties(_ref4, _excluded4);
  return /*#__PURE__*/React.createElement(ToastPrimitives.Close, _extends({
    ref: ref,
    className: cn('absolute right-2 top-2 rounded-md p-1 text-foreground/50 opacity-0 transition-opacity hover:text-foreground focus:opacity-100 focus:outline-none focus:ring-2 group-hover:opacity-100 group-[.destructive]:text-red-300 group-[.destructive]:hover:text-red-50 group-[.destructive]:focus:ring-red-400 group-[.destructive]:focus:ring-offset-red-600', className),
    "toast-close": ""
  }, props), /*#__PURE__*/React.createElement(X, {
    className: "h-4 w-4 "
  }));
});
ToastClose.displayName = ToastPrimitives.Close.displayName;
var ToastTitle = /*#__PURE__*/React.forwardRef(function (_ref5, ref) {
  var className = _ref5.className,
    props = _objectWithoutProperties(_ref5, _excluded5);
  return /*#__PURE__*/React.createElement(ToastPrimitives.Title, _extends({
    ref: ref,
    className: cn('text-sm font-semibold', className)
  }, props));
});
ToastTitle.displayName = ToastPrimitives.Title.displayName;
var ToastDescription = /*#__PURE__*/React.forwardRef(function (_ref6, ref) {
  var className = _ref6.className,
    props = _objectWithoutProperties(_ref6, _excluded6);
  return /*#__PURE__*/React.createElement(ToastPrimitives.Description, _extends({
    ref: ref,
    className: cn('text-sm opacity-90 break-all w-full', className)
  }, props));
});
ToastDescription.displayName = ToastPrimitives.Description.displayName;
export { Toast, ToastAction, ToastClose, ToastDescription, ToastProvider, ToastTitle, ToastViewport };